var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Paper, Select, TextField, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { usePlaylists } from "frontend/src/domain/playlists";
import { PlaylistEntryHeader } from "./header";
import { PlaylistEntryPlaylistSelect } from "./playlist-selection";
import { useViewer } from "../../../../../../../../domain/session";
var playOrderMap = {
    forward: "По возрастанию",
    backward: "По убыванию",
    random: "Случайно",
};
var usePlaylistEntryStyles = makeStyles(function (theme) {
    var _a;
    return ({
        customizationOptionWrapper: (_a = {
                display: "flex",
                flexDirection: "column",
                "& .MuiFormControl-root": {
                    marginTop: theme.spacing(1),
                }
            },
            _a[theme.breakpoints.up("sm")] = {
                flexDirection: "row",
                marginTop: theme.spacing(2),
                "& .MuiFormControl-root": {
                    marginTop: theme.spacing(0),
                    "&:not(:last-child)": {
                        marginRight: theme.spacing(1),
                    },
                },
            },
            _a),
    });
});
export var PlaylistEntry = function (_a) {
    var _b;
    var index = _a.index, playlistId = _a.playlistId, duration = _a.duration, trackCount = _a.trackCount, playlistPlayOrder = _a.playlistPlayOrder, durationOrTrackCountNotSelectedError = _a.durationOrTrackCountNotSelectedError, playlistNotSelectedError = _a.playlistNotSelectedError, onTrackCountChange = _a.onTrackCountChange, onPlaylistDurationChange = _a.onPlaylistDurationChange, onPlaylistChange = _a.onPlaylistChange, onPlaylistPlayOrderChange = _a.onPlaylistPlayOrderChange, onRemove = _a.onRemove;
    var classes = usePlaylistEntryStyles();
    var viewer = useViewer();
    var privatePlaylists = usePlaylists({
        type: "private",
        clientId: (_b = viewer.user) === null || _b === void 0 ? void 0 : _b.clientId,
        take: 200,
        skip: 0,
        isPublished: true,
    });
    var publicPlaylists = usePlaylists({
        type: "public",
        take: 200,
        skip: 0,
        isPublished: true,
    });
    var playlists = privatePlaylists.data && publicPlaylists.data
        ? privatePlaylists.data.items.concat(publicPlaylists.data.items)
        : [];
    var selectedPlaylist = React.useMemo(function () { return playlists.find(function (playlist) { return playlist.id === playlistId; }); }, [playlists, playlistId]);
    var changeTrackCount = function (evt) {
        if (typeof evt.target.value === "string") {
            var value = parseInt(evt.target.value);
            if (!isNaN(value)) {
                onTrackCountChange(value, index);
            }
        }
    };
    var changePlaylist = function (id) { return onPlaylistChange(id, index); };
    var changeDuration = function (evt) {
        if (typeof evt.target.value === "string") {
            var value = parseInt(evt.target.value);
            if (!isNaN(value)) {
                onPlaylistDurationChange(value, index);
            }
        }
    };
    var changePlaylistPlayOrder = function (evt) {
        var value = evt.target.value;
        if (value === "backward" || value === "forward" || value === "random") {
            onPlaylistPlayOrderChange(value, index);
        }
    };
    var remove = function () { return onRemove(index); };
    return (React.createElement(Box, { component: Paper, p: 2 },
        React.createElement(PlaylistEntryHeader, { onRemove: remove, playlist: selectedPlaylist }),
        React.createElement(Box, { mt: 2 },
            playlists ? (React.createElement(PlaylistEntryPlaylistSelect, { playlists: playlists, selectedPlaylistId: playlistId, onChange: changePlaylist, error: playlistNotSelectedError })) : (React.createElement(Skeleton, null)),
            React.createElement(Box, { className: classes.customizationOptionWrapper },
                React.createElement(TextField, { label: "Кол-во треков", type: "number", value: trackCount, onChange: changeTrackCount, error: !!durationOrTrackCountNotSelectedError, inputProps: { min: 0 } }),
                React.createElement(TextField, { label: "Кол-во минут", type: "number", value: duration, onChange: changeDuration, error: !!durationOrTrackCountNotSelectedError, inputProps: { min: 0 } }),
                React.createElement(FormControl, { fullWidth: true },
                    React.createElement(InputLabel, null, "\u041F\u043E\u0440\u044F\u0434\u043E\u043A"),
                    React.createElement(Select, { fullWidth: true, value: playlistPlayOrder, onChange: changePlaylistPlayOrder }, Object.entries(playOrderMap).map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return (React.createElement(MenuItem, { key: key, value: key }, value));
                    }))))),
        durationOrTrackCountNotSelectedError && (React.createElement(Box, { mt: 1 },
            React.createElement(FormHelperText, { error: true }, durationOrTrackCountNotSelectedError)))));
};
